import { EventEmitter, Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class StyleHandlerService {
  adminNotificationEmitter = new EventEmitter<any>();
  
  constructor() {}

  heightHandler(topPadding, defaultHeight, windowHeight) {
    if (windowHeight < defaultHeight) return defaultHeight - topPadding + "px";
    const height = windowHeight - topPadding + "px";
    return height;
  }

  heightHandlerNum(topPadding, defaultHeight, windowHeight) {
    if (windowHeight < defaultHeight) return defaultHeight - topPadding;
    const height = windowHeight - topPadding;
    return height;
  }

  heightHandlerCustom(topPadding, defaultHeight, windowHeight, defaultPadding) {
    if (windowHeight < defaultHeight)
      return defaultHeight - defaultPadding + "px";
    const height = windowHeight - topPadding + "px";
    return height;
  }

  heightHandlerCustomNum(
    topPadding,
    defaultHeight,
    windowHeight,
    defaultPadding
  ) {
    if (windowHeight < defaultHeight) return defaultHeight - defaultPadding;
    const height = windowHeight - topPadding;
    return height;
  }
}
